import { render, staticRenderFns } from "./invoice-batch-errors.vue?vue&type=template&id=2d1959ad&"
import script from "./invoice-batch-errors.vue?vue&type=script&lang=js&"
export * from "./invoice-batch-errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports